import { Component } from '@angular/core';

@Component({
    selector: 'catalog',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class CatalogComponent {}
